import {MessageBoxCancelBtnTexts, MessageBoxConfirmBtnTexts, MessageBoxHeaders, MessageBoxTexts, UserActions} from "../const/ActionsConst";

const initialState = {
    type: undefined,
    header: '',
    text: '',
    show: false
};

const messageBox = (state = initialState, action) => {
    switch (action.type) {
        case UserActions.SHOW_MESSAGE_BOX:
            return {
                ...state,
                type: action.messageBox.type,
                header: action.messageBox.type ? MessageBoxHeaders[action.messageBox.type] : '',
                text: action.messageBox.type ? MessageBoxTexts[action.messageBox.type] : '',
                show: action.messageBox.show,
                confirmText: action.messageBox.type ? MessageBoxConfirmBtnTexts[action.messageBox.type] : undefined,
                cancelText: action.messageBox.type ? MessageBoxCancelBtnTexts[action.messageBox.type] : undefined,
                size: action.messageBox.size
            };
        case UserActions.SHOW_MESSAGE_BOX_BASED_ON_DATA:
            return {
                ...state,
                type: action.messageBox.type,
                header: action.messageBox.header,
                text: action.messageBox.text,
                show: action.messageBox.show,
                confirmText: action.messageBox.confirmText,
                cancelText: action.messageBox.cancelText,
                size: action.messageBox.size,
                data: action.messageBox.data,
                callback: action.messageBox.callback
            };
        default:
            return state;
    }
};

export default messageBox;